import { useCallback, useRef, useState } from "react";

// Approximate per-verse highlight timing for Onyx narration.
// The chapter duration is split across verses by character count
// (an intro line "Book Chapter" is spoken first). Used by Reader & AudioBible.
export function useAudioVerseSync() {
  const [activeIdx, setActiveIdx] = useState(-1);
  const verseTimes = useRef([]);

  const buildTimes = useCallback((audio, data) => {
    if (!audio || !data || !isFinite(audio.duration) || audio.duration <= 0) return;
    const introLen = (data.book_name?.length || 6) + 14;
    const lens = data.verses.map((v) => (v.t?.length || 1) + 1);
    const total = introLen + lens.reduce((s, n) => s + n, 0);
    let acc = introLen;
    verseTimes.current = lens.map((len) => {
      const start = (acc / total) * audio.duration;
      acc += len;
      return start;
    });
  }, []);

  const onTimeUpdate = useCallback((audio, onChange) => {
    const starts = verseTimes.current;
    if (!audio || !starts.length) return;
    const t = audio.currentTime;
    let idx = 0;
    for (let i = 0; i < starts.length; i++) {
      if (t >= starts[i]) idx = i; else break;
    }
    setActiveIdx((prev) => {
      if (prev !== idx) onChange?.(idx);
      return idx;
    });
  }, []);

  const reset = useCallback(() => {
    verseTimes.current = [];
    setActiveIdx(-1);
  }, []);

  return { activeIdx, buildTimes, onTimeUpdate, reset };
}
